import React, { useState, useRef, useEffect } from "react";
import "../Styles/BlurImage.scss";

const BlurImage = ({
  src,
  alt = "Product Visual",
  className = "",
  style = {},
  imgClassName = "",
  priority = false,
  ...props
}) => {
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    if (imgRef.current && imgRef.current.complete) {
      setLoaded(true);
    } else {
      setLoaded(false);
    }
  }, [src]);

  return (
    <div
      className={`blur-image-wrapper ${loaded ? "is-loaded" : "is-loading"} ${className}`}
      style={style}
    >
      <div className="blur-image-placeholder-shimmer" />
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        decoding="async"
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "auto"}
        className={`blur-image-real ${loaded ? "loaded" : "loading"} ${imgClassName}`}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        {...props}
      />
    </div>
  );
};

export default BlurImage;
